<template>
  <div class="illustration-good-pratices-content" id="identidade-visual-ilustracao-boas-praticas" data-search-anchor>
    <div class="illustration-title-good-pratices-wrapper">
      <h1 class="illustration-good-pratices-title-span">{{ illustrationGoodPracticesTitleSpan }}</h1>
      <h1 class="illustration-good-pratices-title">{{ illustrationGoodPracticesTitle }}</h1>      
    </div>
    <div class="illustration-description-good-pratices-wrapper">      
      <div class="icon-wrapper">
        <IconCheck />
        <p class="illustration-good-pratices-description-icon">{{ illustrationGoodPracticesDescription1 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="illustration-good-pratices-description-icon">{{ illustrationGoodPracticesDescription2 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="illustration-good-pratices-description-icon">{{ illustrationGoodPracticesDescription3 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="illustration-good-pratices-description-icon">{{ illustrationGoodPracticesDescription4 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="illustration-good-pratices-description-icon">{{ illustrationGoodPracticesDescription5 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="illustration-good-pratices-description-icon">{{ illustrationGoodPracticesDescription6 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="illustration-good-pratices-description-icon">{{ illustrationGoodPracticesDescription7 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="illustration-good-pratices-description-icon">{{ illustrationGoodPracticesDescription8 }}</p>
      </div>
    </div>    
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import IllustrationPageMixin from '@/mixins/illustration-page-mixin'
import { IllustrationPageStore } from '@/store/visual-identity-page/illustration-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class IllustrationStyleSection extends Mixins(IllustrationPageMixin) {
  illustrationPageStore: PageStoreContract = getModule(IllustrationPageStore, this.$store)

  get illustrationGoodPracticesTitleSpan(): string {
    return this.getElementTitle(9, 0)
  }

  get illustrationGoodPracticesTitle(): string {
    return this.getElementText(9, 0)
  }

  get illustrationGoodPracticesDescription1(): string {
    return this.getElementText(9, 1)
  }  

  get illustrationGoodPracticesDescription2(): string {
    return this.getElementText(9, 2)
  }

  get illustrationGoodPracticesDescription3(): string {
    return this.getElementText(9, 3)
  }

  get illustrationGoodPracticesDescription4(): string {
    return this.getElementText(9, 4)
  }

  get illustrationGoodPracticesDescription5(): string {
    return this.getElementText(9, 5)
  }

  get illustrationGoodPracticesDescription6(): string {
    return this.getElementText(9, 6)
  }
  
  get illustrationGoodPracticesDescription7(): string {
    return this.getElementText(9, 7)
  } 

  get illustrationGoodPracticesDescription8(): string {
    return this.getElementText(9, 8)
  } 

  async getIllustrationPage(): Promise<void> {
    await this.illustrationPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.illustrationPageStore.isLoading) {
      await this.getIllustrationPage()
    }
  }
}
</script>

<style lang="scss">
.illustration-good-pratices-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.illustration-title-good-pratices-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 1rem;
}

.illustration-good-pratices-title-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
  
  margin-right: 5px;
  color: #b3b3b3;
}

.illustration-description-good-pratices-wrapper {  
  position: relative;  

  display: grid;
  grid-template-columns: 50% 50%;  
}

.illustration-good-pratices-description-icon {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  padding-left: 7px;  
  width: 411px;
}

</style>
